import React from 'react';

const ListVisorHead = props => {
  return <div {...props} className="tk-list-visor-head" />;
};

export default ListVisorHead;
